module.exports = __webpack_public_path__ + "img/prescription.728f12fb.svg";